import { onBeforeUnmount } from 'vue'
import client from '../api/client.js'

const sentEvents = new Set()
const queue = []
let flushTimer = null

function sessionId() {
  let id = sessionStorage.getItem('avocash-session-id')
  if (!id) {
    id = crypto.randomUUID()
    sessionStorage.setItem('avocash-session-id', id)
  }
  return id
}

function platform() {
  return /Mobi|Android/i.test(navigator.userAgent) ? 'MOBILE' : 'WEB'
}

function deviceType() {
  const ua = navigator.userAgent
  if (/iPad|Tablet/i.test(ua)) return 'TABLET'
  if (/Mobi|Android/i.test(ua)) return 'MOBILE'
  return 'DESKTOP'
}

export function useEngagementTracker() {
  function send(event) {
    const clientEventId = event.clientEventId || crypto.randomUUID()
    const key = `${clientEventId}:${event.eventType}:${event.contentType}:${event.contentId}`
    if (sentEvents.has(key)) return
    sentEvents.add(key)
    queue.push({
      ...event,
      clientEventId,
      sessionId: sessionId(),
      platform: platform(),
      deviceType: deviceType(),
      occurredAt: new Date().toISOString(),
    })
    if (queue.length >= 10) {
      flush()
    } else {
      clearTimeout(flushTimer)
      flushTimer = setTimeout(flush, 3000)
    }
  }

  function observeViewable(element, event, options = {}) {
    if (!element) return () => {}
    const threshold = options.threshold || 0.5
    const durationMs = options.durationMs || 1000
    let timer
    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0]
      if (entry.isIntersecting && entry.intersectionRatio >= threshold) {
        timer = setTimeout(() => {
          send({ ...event, eventType: 'VIEWABLE_IMPRESSION' })
          observer.disconnect()
        }, durationMs)
      } else {
        clearTimeout(timer)
      }
    }, { threshold: [threshold] })
    observer.observe(element)
    return () => { clearTimeout(timer); observer.disconnect() }
  }

  function trackClick(event) { send({ ...event, eventType: 'CLICK' }) }
  function trackOpen(event) { send({ ...event, eventType: 'OPEN' }) }
  function track(eventType, event) { send({ ...event, eventType }) }

  function flush() {
    if (!queue.length) return
    const events = queue.splice(0, queue.length)
    client.post('/api/engagement/events/batch', { events }).catch(() => {
      queue.unshift(...events.slice(0, 100))
    })
  }

  onBeforeUnmount(flush)

  return { send, observeViewable, trackClick, trackOpen, track, flush }
}
